export enum NotificationsRouteNamesEnum {
  Notifications = 'Notifications',
  AllNotifications = 'AllNotifications',
  BillingNotifications = 'BillingNotifications',
  ProjectManagementNotifications = 'ProjectManagementNotifications',
  Legal = 'Legal',
  PortalActivity = 'PortalActivity',
}
